import { bytesToHex, hexToBytes } from "@sundae/cardano-utils";
import { CborDeserializableEntities, } from "./CborSerializableEntities";
import { JsonDeserializableEntities, } from "./JsonSerializableEntities";
/**
 * Cbor encode an `TCborSerializable` wasm entity
 * @param w
 * @returns
 */
export const wasmToCbor = (w) => w.to_bytes();
/**
 * Cbor encode and then hex encode a `TCborSerializable` wasm entity
 * @param w
 * @returns
 */
export const wasmToCborHex = (w) => bytesToHex(wasmToCbor(w));
/**
 * CborHex decoder factory for an `TCborDeserializable` entity
 * @param a the entity
 * @returns cbor decoder
 */
export const getCborHexToWasm = (a) => (cborHex) => a.from_bytes(hexToBytes(cborHex));
/**
 * CborHex to Wasm decoders
 * @deprecated remove side effect
 */
export const CborHexToWasm = Object.fromEntries(CborDeserializableEntities.map((s) => [
    s.name,
    getCborHexToWasm(s),
]));
/**
 * Stringify the JSON representation of a `TJsonSerializable` wasm entity
 * @param w
 * @returns
 */
export const wasmToJson = (w) => w.to_json();
/**
 * JSON to Wasm unmarshaller factory
 * @param a the entity
 * @returns
 */
export const getJsonToWasm = (a) => (jsonStr) => a.from_json(jsonStr);
/**
 * JSON to Wasm
 * @deprecated remove side effect
 */
export const JsonToWasm = Object.fromEntries(JsonDeserializableEntities.map((s) => [
    s.name,
    getJsonToWasm(s),
]));
/**
 * Unmarshall a `TJsonSerializable` wasm entity
 * @param w
 * @returns
 */
export const wasmToJs = (w) => JSON.parse(wasmToJson(w));
/**
 * Js to Wasm factory
 * @param a the entity
 * @returns
 */
export const getJsToWasm = (a) => (js) => a.from_json(JSON.stringify(js));
/**
 * Js to Wasm
 *
 * @deprecated remove side effect
 */
export const JsToWasm = Object.fromEntries(JsonDeserializableEntities.map((s) => [
    s.name,
    getJsToWasm(s),
]));
//# sourceMappingURL=WasmSerialization.js.map